export const colors = {
  white: "#ffffff",
  skyblue: "#61dafb",
  darkgrey: "#282c34",
  charcoalGrey: "#343a46",
  grey: "#a1a1a1",
};
